import { render } from "./Header.vue?vue&type=template&id=25acaaf1&scoped=true"
const script = {}

import "./Header.vue?vue&type=style&index=0&id=25acaaf1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25acaaf1"]])

export default __exports__